import { render, staticRenderFns } from "./ProvinceAndDistrictSelector.vue?vue&type=template&id=52eb62bc&lang=pug&"
import script from "./ProvinceAndDistrictSelector.vue?vue&type=script&lang=ts&"
export * from "./ProvinceAndDistrictSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ProvinceAndDistrictSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports